import { SpineUtil } from "@lib/titan2/dist/util/view/SpineUtil";
import { gsap } from "gsap";
/**
 * A firework with a head and tail spine.
 */
export class Firework {
    constructor(head, tail) {
        this.head = head;
        this.tail = tail;
    }
    async launch(from, to, duration) {
        this.animation?.kill();
        SpineUtil.play(this.head, "static");
        this.tail.cleanup();
        this.head.position.copyFrom(from);
        let lastTime = 0;
        const { x: fromX, y: fromY } = from;
        const { x: toX, y: toY } = to;
        const dx = toX - fromX;
        const dy = toY - fromY;
        const verticalEase = toY < fromY ? gsap.parseEase("power2.out") : gsap.parseEase("power2.in");
        this.animation = gsap.to({}, {
            duration,
            onUpdate: () => {
                // Emit tail particles interpolated between the last time and the current time to compensate for low framerates and prevent gaps.
                const time = this.animation.time();
                for (let i = lastTime; i < time; i += this.tail.frequency) {
                    const interpolatedProgress = i / duration;
                    const interpolatedX = fromX + dx * interpolatedProgress;
                    const interpolatedY = fromY + dy * verticalEase(interpolatedProgress);
                    this.tail.resetPositionTracking();
                    this.tail.updateSpawnPos(interpolatedX, interpolatedY);
                    this.tail.emitNow();
                }
                // Update the head and the tail to the current progress.
                const progress = this.animation.progress();
                const x = fromX + dx * progress;
                const y = fromY + dy * verticalEase(progress);
                this.tail.resetPositionTracking();
                this.tail.updateSpawnPos(x, y);
                this.head.position.set(x, y);
                // Rotate the head based on the direction of travel from the last progress.
                const lastX = fromX + dx * lastTime / duration;
                const lastY = fromY + dy * verticalEase(lastTime / duration);
                this.head.rotation = Math.atan2(y - lastY, x - lastX);
                lastTime = time;
            }
        });
        await this.animation;
    }
    async detonate() {
        this.animation?.kill();
        return new Promise(resolve => SpineUtil.play(this.head, "explode", resolve));
    }
}
//# sourceMappingURL=Firework.js.map